module.exports = __webpack_public_path__ + "static/media/webBlueOutline-sm.aa9c5d4b.svg";